import { render, staticRenderFns } from "./MaterialChoiceWidget.vue?vue&type=template&id=b1f2247e&scoped=true&"
import script from "./MaterialChoiceWidget.vue?vue&type=script&lang=js&"
export * from "./MaterialChoiceWidget.vue?vue&type=script&lang=js&"
import style0 from "./MaterialChoiceWidget.vue?vue&type=style&index=0&id=b1f2247e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f2247e",
  null
  
)

export default component.exports